import { createContext, useContext } from 'react';
import type { IAdminAuthService } from '@src/domain/interfaces';

/**
 * Admin Auth Context - Presentation layer
 * Provides admin authentication service to child components
 */
export const AdminAuthContext = createContext<IAdminAuthService | null>(null);

/**
 * Hook to access admin auth service from context
 * @returns Admin auth service instance
 * @throws Error if used outside AdminAuthProvider
 */
export const useAdminAuthContext = (): IAdminAuthService => {
  const context = useContext(AdminAuthContext);
  if (!context) {
    throw new Error('useAdminAuthContext must be used within AdminAuthProvider');
  }
  return context;
};
